import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  ViewChild,
} from '@angular/core';
import { Page } from '@bloomreach/spa-sdk';
import { BrPageComponent } from '@bloomreach/ng-sdk';
import { Subscription } from 'rxjs';
import { SkiptoHeaderService } from '@services/skipto-header.service';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'ft-equal-cols',
  templateUrl: './equal-cols.component.html',
  styleUrls: ['./equal-cols.component.scss'],
})
export class EqualColsComponent implements AfterViewInit, OnDestroy {
  /**
   * Bloomreach page object
   */
  @Input() page!: Page;

  /**
   * Component configuration
   */
  configuration: BrPageComponent['configuration'];

  @ViewChild('mainContent') mainContent: ElementRef;
  private skipToSubscription: Subscription;

  constructor(private skipToHeaderService: SkiptoHeaderService) {}

  /**
   * Page loaded
   */
  public ngAfterViewInit(): void {
    // Subscribe to the boolean value emitted by skipToHeaderService
    this.skipToSubscription = this.skipToHeaderService
      .getSkipToHeaderBoolean$()
      // Filter out falsy values emitted by skipToHeaderService
      .pipe(filter((skipTo) => skipTo))
      // Perform the focus and scrollIntoView actions when a truthy value is emitted by skipToHeaderService
      .subscribe(() => {
        this.skipToHeaderService.scrollToMainContent(this.mainContent);
      });
  }
  public ngOnDestroy(): void {
    // Unsubscribe from the subscription when the component is destroyed
    this.skipToSubscription?.unsubscribe();
  }
}
